import React from 'react';

const CustomButton = ({ children, onClick, className = '' }) => {
  return (
    <button 
      onClick={onClick}
      className={`
        px-6 xs:px-7 sm:px-8 md:px-12 
        py-2 
        bg-white 
        rounded-full 
        text-black 
        text-sm xs:text-base
        font-medium 
        font-roboto 
        transition-all 
        border-2
        border-[#b00c00]
        hover:bg-[#b00c00] 
        hover:text-white
        hover:border-[#8b123b]
        ${className}
      `}
    >
      {children}
    </button>
  );
};

export default CustomButton;